module.exports = __webpack_public_path__ + "static/image2-ea10ee741a47c59a92edd2ea210d67d7.jpg";